import APIS_CONSTANTS from "./ApiConstants";
import http from "./http";

class WalletServices {
  // Get wallet account information
  getWalletAccount() {
    return http.get(APIS_CONSTANTS.getWalletAccount);
  }

  // Get user tier
  getWalletTier({ tierId }) {
    return http.get(`${APIS_CONSTANTS.getWalletTier}?tier_id=${tierId}`);
  }

  // Get points history
  getPointsHistory() {
    return http.get(`${APIS_CONSTANTS.getPointsHistory}`);
  }

  // Get points history
  getWalletDesign({ tierId }) {
    // API expects tierId as a path segment, not a query param
    return http.get(`${APIS_CONSTANTS.getWalletDesign}/${tierId}`);
  }

  // get google wallet qr code
  getGoogleWalletQrCode() {
    return http.get(`${APIS_CONSTANTS.getGoogleWalletQrCode}`, {
      responseType: "blob",
    });
  }

  // get apple wallet qr code
  getAppleWalletQrCode() {
    return http.get(`${APIS_CONSTANTS.getAppleWalletQrCode}`, {
      responseType: "blob",
    });
  }
}

export default new WalletServices();
